import { render, staticRenderFns } from "./scalendar.vue?vue&type=template&id=1192aaa0&scoped=true&"
import script from "./scalendar.vue?vue&type=script&lang=js&"
export * from "./scalendar.vue?vue&type=script&lang=js&"
import style0 from "./scalendar.vue?vue&type=style&index=0&id=1192aaa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1192aaa0",
  null
  
)

export default component.exports